/**
 * Smart truncate that only truncates if the string exceeds the preservation limit
 * @param str - The string to potentially truncate
 * @param maxLength - The maximum length to preserve
 * @param ellipsisPosition - Where to place the ellipsis ('middle' or 'end')
 * @returns The original string if it's shorter than maxLength, otherwise truncated
 */
export function smartTruncate(
  str: string,
  maxLength: number,
  ellipsisPosition: 'middle' | 'end' = 'middle'
): string {
  if (!str || str.length <= maxLength) {
    return str;
  }

  if (ellipsisPosition === 'end') {
    return `${str.slice(0, maxLength)}...`;
  }

  // Middle truncation (default)
  const startChars = Math.ceil((maxLength - 3) / 2);
  const endChars = Math.floor((maxLength - 3) / 2);
  return `${str.slice(0, startChars)}...${str.slice(-endChars)}`;
}
